import { useEffect, useCallback } from 'react';
import { webSocketService } from '../services/websocket/websocket.service';

// Importar tipos directamente
import type { NewOrderEvent, OrderStatusChangeEvent } from '../services/websocket/websocket.service';

interface UseOrderWebSocketProps {
  onNewOrder?: (event: NewOrderEvent) => void;
  onStatusChange?: (event: OrderStatusChangeEvent) => void;
}

export const useOrderWebSocket = ({ onNewOrder, onStatusChange }: UseOrderWebSocketProps) => {
  const handleNewOrder = useCallback((event: NewOrderEvent) => {
    onNewOrder?.(event);
  }, [onNewOrder]);

  const handleStatusChange = useCallback((event: OrderStatusChangeEvent) => {
    onStatusChange?.(event);
  }, [onStatusChange]);

  useEffect(() => {
    // Suscribirse a eventos de pedidos
    webSocketService.addEventListener('new_order', handleNewOrder);
    webSocketService.addEventListener('order_status_change', handleStatusChange);

    return () => {
      webSocketService.removeEventListener('new_order', handleNewOrder);
      webSocketService.removeEventListener('order_status_change', handleStatusChange);
    };
  }, [handleNewOrder, handleStatusChange]);
};

export default useOrderWebSocket;
